import { decrypt, encrypt } from '@/utils/cryptoJS'

const CURRENT_CONTEXT_SECRET = '@#$%^&*!!123'
const CURRENT_ORGANIZATION_KEY = 'organizationId'
const CURRENT_PROJECT_KEY = 'currentProjectId'

const getCurrentContextId = (key) => {
    const value = localStorage.getItem(key)
    if (value === null) return undefined
    if (value === '') return ''
    const decryptedValue = decrypt(value, CURRENT_CONTEXT_SECRET)
    if (decryptedValue === '') return ''
    const numberValue = Number(decryptedValue)
    return Number.isNaN(numberValue) ? decryptedValue : numberValue
}

export const SET_TOKEN=(token)=>{
    sessionStorage.setItem("Token",token)
}
export const GET_TOKEN=()=>{
    return sessionStorage.getItem("Token")
}
export const REMOVE_TOKEN=()=>{
    return sessionStorage.removeItem("Token")
}
export const SET_platForm=(platForm)=>{
    sessionStorage.setItem("platForm",JSON.stringify(platForm))
}
export const GET_PLATFORM=()=>{
    return sessionStorage.getItem("platForm")
}
export const REMOVE_PLATFORM=()=>{
    return sessionStorage.removeItem("platForm")
}
export const SET_MENU=(Menu)=>{
    sessionStorage.setItem("Menu",JSON.stringify(Menu))
}
export const GET_MENU=()=>{
    return sessionStorage.getItem("Menu")
}
export const REMOVE_MENU=()=>{
    return sessionStorage.removeItem("Menu")
}
export const SET_PLAYLOAD=(playLoad)=>{
    sessionStorage.setItem("playLoad",JSON.stringify(playLoad))
}
export const GET_PLAYLOAD=()=>{
    const playLoad = JSON.parse(sessionStorage.getItem("playLoad"))
    if (!playLoad) return playLoad

    const userId = playLoad['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']
    if (userId == 1) {
        const organizationId = GET_CURRENT_ORGANIZATION_ID()
        const projectId = GET_CURRENT_PROJECT_ID()

        if (organizationId !== undefined && playLoad.OrganizationList) {
            const organization = JSON.parse(playLoad.OrganizationList)
            organization.organizationId = organizationId
            playLoad.OrganizationList = JSON.stringify(organization)
        }
        if (projectId !== undefined) {
            playLoad.ProjetList = JSON.stringify(projectId === '' ? [] : [projectId])
        }
    }

    return playLoad
}
export const REMOVE_PLAYLOAD=()=>{
    return sessionStorage.removeItem("playLoad")
}
export const SET_PROJECTID=(projectID)=>{
    sessionStorage.setItem("projectId",JSON.stringify(projectID))
}
export const GET_PROJECTID=()=>{
    return JSON.parse(sessionStorage.getItem("projectId"))
}
export const REMOVE_PROJECTID=()=>{
    return sessionStorage.removeItem("projectId")
}
export const SET_HHTOKEN=(token)=>{
    sessionStorage.setItem("hhtoken",JSON.stringify(token))
}
export const GET_HHTOKEN=()=>{
    return JSON.parse(sessionStorage.getItem("hhtoken"))
}
export const REMOVE_HHTOKEN=()=>{
    return sessionStorage.removeItem("hhtoken")
}
export const SET_USERID=(userID)=>{
    sessionStorage.setItem("userId",JSON.stringify(userID))
}
export const GET_USERID=()=>{
    return JSON.parse(sessionStorage.getItem("userId"))
}
export const REMOVE_USERID=()=>{
    return sessionStorage.removeItem("userId")
}

export const SET_CURRENT_ORGANIZATION_ID=(organizationId)=>{
    localStorage.setItem(CURRENT_ORGANIZATION_KEY, encrypt(String(organizationId), CURRENT_CONTEXT_SECRET))
}
export const GET_CURRENT_ORGANIZATION_ID=()=>{
    return getCurrentContextId(CURRENT_ORGANIZATION_KEY)
}
export const SET_CURRENT_PROJECT_ID=(projectId)=>{
    if (projectId === '' || projectId === undefined || projectId === null) {
        localStorage.setItem(CURRENT_PROJECT_KEY, '')
        return
    }
    localStorage.setItem(CURRENT_PROJECT_KEY, encrypt(String(projectId), CURRENT_CONTEXT_SECRET))
}
export const GET_CURRENT_PROJECT_ID=()=>{
    return getCurrentContextId(CURRENT_PROJECT_KEY)
}
export const REMOVE_CURRENT_CONTEXT=()=>{
    localStorage.removeItem(CURRENT_ORGANIZATION_KEY)
    localStorage.removeItem(CURRENT_PROJECT_KEY)
}
